// ScoreDisplay.jsx
import React from 'react';
import PropTypes from 'prop-types';
import ScoreProgressBar from './ScoreProgressBar';

const ScoreDisplay = ({ score }) => {
  return (
    <div className="score-display-container">
      <ScoreProgressBar score={score} />
    </div>
  );
};

ScoreDisplay.propTypes = {
  score: PropTypes.number.isRequired, // Expecting a number between 0-100
};

export default ScoreDisplay;
